import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Button,
} from "@mui/material";
import dayjs from "dayjs"; // for default date

const paymentOptions = [
  { label: "Paid – Full", value: "paid-full" },
  { label: "Paid – Partial, Keep Balance Open", value: "paid-partial" },
  {
    label: "Paid – Partial, Write-off Balance",
    value: "paid-partial-write-off",
  },
];

const paymentMethods = ["Cash", "Credit Card", "Check", "Bank Transfer"];

const PaymentDialog = ({ open, onClose, billedAmount, onSubmit }) => {
  const [paymentType, setPaymentType] = useState("paid-full");
  const [paidDate, setPaidDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [trackingNumber, setTrackingNumber] = useState("");
  const [method, setMethod] = useState("");
  const [amount, setAmount] = useState(billedAmount || "");

  useEffect(() => {
    if (paymentType === "paid-full") {
      setAmount(parseFloat(billedAmount) || "");
    }
  }, [paymentType, billedAmount]);

  const handleSubmit = () => {
    onSubmit({
      action: paymentType,
      paid_date: paidDate,
      payment_tracking_number: trackingNumber,
      payment_method: method,
      paid_amount: parseFloat(amount),
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Bill Payment</DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}
      >
        <FormControl fullWidth variant="standard">
          <InputLabel shrink>Payment Type</InputLabel>
          <Select
            value={paymentType}
            onChange={(e) => setPaymentType(e.target.value)}
          >
            {paymentOptions.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          type="date"
          label="Paid Date"
          value={paidDate}
          onChange={(e) => setPaidDate(e.target.value)}
          slotProps={{
            inputLabel: {
              shrink: true,
            },
          }}
          fullWidth
          variant="standard"
        />

        <TextField
          label="Payment Tracking Number"
          value={trackingNumber}
          onChange={(e) => setTrackingNumber(e.target.value)}
          fullWidth
          variant="standard"
        />

        <FormControl fullWidth variant="standard">
          <InputLabel>Payment Method</InputLabel>
          <Select value={method} onChange={(e) => setMethod(e.target.value)}>
            {paymentMethods.map((m) => (
              <MenuItem key={m} value={m}>
                {m}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <TextField
          label="Paid Amount"
          type="number"
          value={amount}
          onChange={(e) => setAmount(parseFloat(e.target.value))}
          fullWidth
          disabled={paymentType === "paid-full"}
          variant="standard"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSubmit}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentDialog;
